export const generateRandomNumberFunc = () => {
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    const newValue = array[0] / 2 ** 32; // Normalize to 0–1
    return newValue;
}; 